import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ChatMessage, ChatRoomDto} from '../../models/createChatRoomRequest';
import {UserDto} from '../../../user/data/userDto';
import {ChatService} from '../../services/chat.service';
import {SendChatMessageRequest} from '../../models/sendChatMessageRequest';
import {ChatHandler} from '../../../app-common/services/signalr/handlers/chatHandler';
import {UserService} from '../../../user/services/user/user.service';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'app-chat-room',
  templateUrl: './chat-room.component.html',
  styleUrls: ['./chat-room.component.scss']
})
export class ChatRoomComponent implements OnInit, OnChanges {
  @Input() room: ChatRoomDto;

  message: string = '';

  @ViewChild('messagesElement') messagesElement: ElementRef;

  constructor(private chatService: ChatService,
              public userService: UserService,
              private loggingService: LoggerService) { }

  ngOnInit(): void {
    ChatHandler.instance.onReceive.subscribe(message => {
      this.scrollToBottomOfChat();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.room.previousValue !== changes.room.currentValue && !!changes.room.currentValue) {
      this.scrollToBottomOfChat();
    }
  }

  get participantsToShow() {
    if (this.room.participants.length >= 3) {
      return this.room.participants.slice(0, 3);
    } else {
      return this.room.participants;
    }
  }

  get miscParticipants() {
    return '+' + (this.room.participants.length - 3);
  }

  get miscParticipantsNames() {
    return this.room.participants.slice(3).map(p => p.username).join(', ');
  }

  getParticipantIcon(participant: UserDto) {
    return participant.username[0].toUpperCase();
  }

  sendMessage() {
    if (this.message.length === 0) {
      return;
    }
    const request = new SendChatMessageRequest();
    request.chatId = this.room.room.id;
    request.message = this.message;
    this.chatService.sendChatMessage(request);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.ChatRoom, 'Sent a message into room ' + request.chatId);
    this.message = '';
  }

  getParticipantFromMessage(message: ChatMessage) {
    return this.room.participants.find(p => p.accountId === message.createdBy);
  }
  getParticipantFirstName(participant: UserDto) {
    return participant.username.split(' ')[0];
  }


  scrollToBottomOfChat() {
    setTimeout(() => {
      if (this.messagesElement) {
        this.messagesElement.nativeElement.scrollTop = this.messagesElement.nativeElement.scrollHeight;
      }
    }, 0);
  }
}
